import { Table } from 'ui/table';
import { TILE_TITLES } from '../../constants';
import { ParsedChangelogData, RowType } from './types';
import { StyledRow, Action, Cell, Id } from './styles';

const BASE_HEADER_COLUMNS = [
  {
    name: 'Action',
    value: 'action',
    align: 'flex-start',
    RowCell: ({ row }: RowType) => (
      <Action data-test={'changelog-column-action'} changeType={row.action}>
        {row.action}
      </Action>
    ),
  },
  {
    name: 'NodeId',
    value: 'node',
    align: 'flex-start',
    RowCell: ({ row }: RowType) => (
      <Cell data-test={'changelog-column-id'}>
        {row.liveWorkflowNodeId ? <Id>{`ID ${row.liveWorkflowNodeId}`}</Id> : <Id>New</Id>}
      </Cell>
    ),
  },
  {
    name: 'NodeType',
    value: 'nodeType',
    align: 'flex-start',
    RowCell: ({ row }: RowType) => (
      <Cell data-test={'changelog-column-nodetype'}>
        <span>{TILE_TITLES[row.nodeType]}</span>
      </Cell>
    ),
  },
];

type ChangelogProps = {
  parsedData: ParsedChangelogData[];
  changelogTableTest?: string;
  changelogRowTest?: string;
};

export const Changelog = ({ parsedData, changelogRowTest, changelogTableTest }: ChangelogProps) => {
  return (
    <Table data-test={changelogTableTest}>
      <StyledRow data-test={changelogRowTest} rows={parsedData} columns={BASE_HEADER_COLUMNS} />
    </Table>
  );
};
